import { gql, useQuery } from '@apollo/client';

import { CHAT_SESSION_PAGINATION } from '@/components/SearchAssistant/constants';
import { useEffect } from 'react';

const CHAT_SESSIONS_QUERY = gql`
  query chatSessions($pagination: PaginationInput) {
    chatSessions(pagination: $pagination) {
      chatSessions {
        id
        title
        displayTitle
        createdAt
        updatedAt
        user {
          id
        }
      }
      totalCount
    }
  }
`;

export const useGetSessions = (options = {}) => {
  const {
    perPage = CHAT_SESSION_PAGINATION.DEFAULT_PER_PAGE,
    page = CHAT_SESSION_PAGINATION.DEFAULT_PAGE,
    ...queryOptions
  } = options;

  const { data, loading, error, refetch, fetchMore, startPolling, stopPolling } = useQuery(
    CHAT_SESSIONS_QUERY,
    {
      variables: {
        pagination: {
          perPage,
          page,
        },
      },
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
      ...queryOptions,
    },
  );

  useEffect(() => {
    const lastSession = data?.chatSessions?.chatSessions?.[0];
    if (lastSession?.id && !lastSession.title) {
      // If the most recent session doesn't have a title, start polling for updates
      startPolling(5000);
    }

    if (lastSession?.title && loading) {
      stopPolling();
    }

    // Stop polling when component unmounts
    return () => stopPolling();
  }, [data, loading, startPolling, stopPolling]);

  return {
    loading,
    error,
    data,
    refetch,
    fetchMore,
  };
};
